import axios from 'axios'
import qs from 'qs'
import VisitiorTracking from '../../services/visitorTracking'

export function postReviewResponse (reviewId, positive) {
  let data = qs.stringify({
    review: reviewId,
    cookieId: VisitiorTracking.getVisitorID()
  })

  return axios.post('/?fc=module&module=dbs_productsreviews&controller=api&action=' + (positive ? 'addReviewLike' : 'addReviewDislike'),
    data, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
}

export async function addReviewResponse (reviewId, positive) {
  const response = await postReviewResponse(reviewId, positive)

  return response.data
}



// WEBPACK FOOTER //
// ./src/api/productReviews/addReviewResponse.js